import Vue from 'vue'
import '../hero-short/hero-short.vue'

export default el => new Vue({
  name: 'HeroShort',
  el,
})